module.exports = "fragment FeatureFragment on Feature {\n  id\n  title\n  subtitle\n  description\n}\n"